module.exports = __webpack_public_path__ + "static/media/hero-banner.e7bd1786.svg";